import { Box, Grid, Typography } from "@mui/material";
import logo from "../../../image/okprintLogo.jpg";
import { useEffect, useState } from "react";
import { stylebox, TextStyle } from "../../Client/home";
import { useSelector } from "react-redux";
import TimeCamera from "../../../composant/camera/TimeCamera";
import { Api_Token } from "../../../env";
import ImageImpression from "../../../composant/impressions/Imagesimpression";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";

function CameraPageBox() {
  const { user } = useSelector((state) => state.Auth);
  const [step, setStep] = useState(0);
  const [product, setProduct] = useState(null);
  const [capturedBlob, setCapturedBlob] = useState(null);
  const [srcRm, setSrcRm] = useState(null);
  const [Background, setBackground] = useState(null);
  const [text, setText] = useState("");
  const [color, setColor] = useState("#ffffff");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [backgroundUrls, SetBackgroundUrls] = useState([]);
  useEffect(() => {
    setLoading(true);
    if (user?.idEvent) {
      setStep(1);
      setProduct(user.Event.Produit);
      SetBackgroundUrls(user.Event.BackgroundEvents);
    }
    setLoading(false);
  }, []);
  const sendtoServeur = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      // Support single or multiple photos
      if (Array.isArray(capturedBlob)) {
        capturedBlob.forEach((blob, idx) => {
          const file = new File([blob], `camera_${Date.now()}_${idx + 1}.jpg`, {
            type: "image/jpeg",
          });
          formData.append("photos", file);
        });
      } else {
        const file = new File([capturedBlob], `camera_${Date.now()}.jpg`, {
          type: "image/jpeg",
        });
        formData.append("photo", file);
      }
      formData.append("idProduit", product.id);
      formData.append("idImprimant", 13);
      formData.append("text", text || "");
      formData.append("logo", product.logo || "");
      formData.append("color", color || "#ffffff");
      formData.append("srcRm", srcRm ? srcRm : null);
      formData.append("bg", Background ? Background?.Url : null);
      formData.append("BackgroundImage", product.BackgroundImage || "");

      const response = await Api_Token.post("command/PhotoBox", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (event) => {
          const percent = Math.round((event.loaded * 100) / event.total);
          console.log(`Upload: ${percent}%`);
        },
      });

      console.log("Server response:", response.data);
      setData(response.data);
      setStep(2);
      alert("Photo uploaded successfully!");
      setLoading(false);
    } catch (err) {
      console.error("Error uploading photo:", err);
      alert("Failed to upload photo");
      setLoading(false);
    }
  };

  console.log("product", product);
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            src={logo}
            alt="OK Print Logo"
            sx={{ maxWidth: "300px", mb: 2, display: "block", margin: "auto" }}
          />
        </Grid>
        {step === 0 && user?.idMagasin && (
          <ProductBox
            onSelect={(p) => {
              setProduct(p);
              setStep(1);
            }}
          />
        )}
        {step === 1 && (
          <Grid item xs={12} textAlign="center">
            <TimeCamera
              handleConfirm={sendtoServeur}
              setCapturedBlob={setCapturedBlob}
              captureBlob={capturedBlob}
              cadrage={product?.cadrage}
              displayText={product?.text}
              setSrcRm={setSrcRm}
              srcRm={srcRm}
              setBackground={setBackground}
              Background={Background}
              text={text}
              setText={setText}
              removeBg={product.removeBg}
              setColor={setColor}
              color={color}
              multiple={
                product.type === "multiple" ? product.NumberMultiple : false
              }
              type={product?.NomProduit}
              backgroundUrls={backgroundUrls}
              setLoading={setLoading}
              idEvent={user?.idEvent ? user.idEvent : null}
            />
          </Grid>
        )}
        {step === 2 && (
          <Grid item xs={12} textAlign="center">
            <ImageImpression
              images={data.images}
              data={data}
              displayEdit={false}
            />
          </Grid>
        )}
      </Grid>
      <BackLoadingSimple open={loading} />
    </Box>
  );
}

function ProductBox({ onSelect }) {
  const { Produits } = useSelector((state) => state.dataApp);
  return (
    <Box>
      <Grid container spacing={2}>
        {Produits?.map((p) => (
          <Grid item xs={6}>
            <div
              onClick={() => {
                onSelect(p);
              }}
              style={{ textAlign: "center" }}
            >
              <Box sx={stylebox}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Box
                    component="img"
                    src={p.url_Image}
                    alt="polaroid"
                    sx={{
                      borderRadius: "30px",
                      width: { xs: "100%", sm: "50%" }, // This will be 50% on extra small screens and 100% on small screens and up
                    }}
                  />
                </div>
                <Typography variant="h6" sx={TextStyle}>
                  Tirage {p.NomProduit}
                </Typography>
              </Box>
            </div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default CameraPageBox;
